import {createSlice, PayloadAction, AnyAction} from '@reduxjs/toolkit';
import {IErrorPayload, IErrorState} from 'modules/errors/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const errorsModuleName = 'errors';

const initialState: IErrorState = {
    errorsList: {},
};

const errorsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return payload[errorsModuleName];
        });
    },
    initialState,
    name: errorsModuleName,
    reducers: {
        actionFlushErrors(state: IErrorState) {
            state.errorsList = {};
        },

        actionRemoveError(state: IErrorState, {payload}: PayloadAction<string>) {
            state.errorsList[payload] = null;
        },

        actionSetError(state: IErrorState, {payload}: PayloadAction<IErrorPayload>) {
            state.errorsList[payload.moduleName] = payload.errors;
        },
    },
});

export const {
    actions: {actionFlushErrors, actionSetError, actionRemoveError},
} = errorsSlice;

export const {reducer: errorsReducer} = errorsSlice;
